module.exports = __webpack_public_path__ + "static/media/30.2ee1ab04.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/30.png
// module id = 884
// module chunks = 0